export default __webpack_public_path__ + "static/media/creative-side-image.c3750f23.png";